import type { ReactNode } from 'react';
import { useFela } from 'react-fela';

import { container } from './Layout.rules';

export const Layout = ({ children }: { children: ReactNode }) => {
    const { css } = useFela();

    return <div className={css(container)}>{children}</div>;
};
